import { createAsyncThunk } from '@reduxjs/toolkit';
import { setSelectedProjectId } from 'scenes/Project/store/actions/projectActions';
import { setProject } from 'store/actions/setProject';
import { selectUserActiveEmployerId } from 'store/user/selectors.js/user.selectors';
import { handleChangeActiveEmployer } from 'store/user/thunks/handleChangeActiveEmployer.thunk';
import { setSearchFilter } from '../actions/projectSearch.actions';
import { selectProjects } from '../selectors/projectsSelectors';

export const selectProject = createAsyncThunk(
  'projects/selectProject',
  async (projectId, { getState, dispatch }) => {
    const state = getState();

    const projects = selectProjects(state);

    const selectedProject = projects[projectId];

    const activeEmployerId = selectUserActiveEmployerId(getState());

    dispatch(setProject(selectedProject));
    dispatch(setSelectedProjectId(projectId));
    dispatch(setSearchFilter(''));

    if (
      selectedProject &&
      selectedProject.businessTypeEnum === 'EMPLOYER' &&
      !activeEmployerId
    ) {
      dispatch(
        handleChangeActiveEmployer({ activeEmployerId: selectedProject.id })
      );
    }
  }
);
